<template>
  <form :id="'login-' + commonParams.state.dwd_appid" :name="'login-' + commonParams.state.dwd_appid">
    <input-group
      v-model="username"
      placeholder="请输入用户名"
      name="username"
      type="text"
      icon="icon-user"
      :iconStyle="style('iUser')"
      :inputGroupStyle="style('inputGroup')"
      :inputStyle="style('input')"
    />
    <input-group
      v-model="password"
      placeholder="请输入密码"
      name="password"
      :type="[pwdViewFlag ? 'text' : 'password']"
      icon="icon-pwd"
      autocomplete="current-password"
      :iconStyle="style('iPwd')"
      :inputGroupStyle="style('inputGroup')"
      :inputStyle="style('pwdInput')">
      <i :class="[pwdViewFlag ? 'i-icon-closeEye' : 'i-icon-openEye','icon']"
         :style="{fontWeight:'bold',cursor:'pointer'}"
         @click="pwdViewFlag=!pwdViewFlag"
         @mouseover="$event.target.style.fontWeight='normal'"
         @mouseout="$event.target.style.fontWeight='bold'"
      />
    </input-group>

    <div class="form-group" v-if="ncParams.is_nc" id="np-verify-login"></div>
    
    <input-group
      v-if="isSmsVerify"
      v-model="smsCode"
      type="text"
      inputClass="code"
      icon="icon-sms"
      placeholder="输入验证码"
    >
      <div class="sms-code">
        <button type="button" @click="getMobileCode">获取验证码</button>
      </div>
    </input-group>
    
    <div class="form-group btn-group">
      <button type="button" :style="style('loginButton')" @click.stop="login">登录</button>
    </div>
  </form>
</template>

<script>
import InputGroup from "./InputGroup"
import checkFormMixin from '@/libs/checkFormMixin'
import {commonParams} from '@/libs/commonParamsStore.js'
import gumIconUser from '@/assets/gum-icon-user.png'
import gumIconPwd from '@/assets/gum-icon-pwd.png'
import {getUrlQueryVar} from "@/libs/util";

export default {
  name: 'LoginForm',
  components: {InputGroup},
  props:['ncParams','isSmsVerify'],
  mixins: [checkFormMixin],
  data(){
    return {
      username: '',
      password: '',
      smsCode: '',
      commonParams,
      pwdViewFlag: false,
      styleMap:{
        gum20210108121500: {
          loginButton: {
            background: '#FC7316',
            borderRadius: '5px',
          },
          iUser:{
            backgroundImage: 'url(' + gumIconUser + ')',
            width: '36px',
            height: '36px',
            margin: 0,
          },
          iPwd:{
            backgroundImage: 'url(' + gumIconPwd + ')',
            width: '36px',
            height: '36px',
            margin: 0,
          },
          inputGroup:{
            height: '36px',
          },
          input:{
            marginLeft: '10px',
          },
          pwdInput:{
            marginLeft: '10px',
            width: '230px'
          },
        }
      }
    }
  },
  methods:{
    async login(){
      let data = {...this.commonParams.state,'username':this.username,'password':this.password}
      if(this.isSmsVerify){
        data['sms_code'] = this.smsCode
      }
      if(!this.checkUser(data)){
        return
      }
      if(!this.isSmsVerify && this.ncParams.is_nc){
        const ncParams = this.checkNcParams()
        if(!ncParams){
          return
        }
        data = {...data,...ncParams}
      }
      let ret = await this.$apis.login(data,null,() => {
        this.ncParams.is_nc = true
        this.$emit('resetNc')
        return false
      })
      let msg = "密码过于简单:，密码需要数字、小写字母、大写字母、符号中至少三种.请点击'忘记密码'重置密码"
      if(!this.checkPassword( this.password,msg )){
        return
      }

      const payload = {
        direct: true,
        sso_token: ret.sso_token,
        sso_username: this.username
      }
      this.$emit('success',payload)

    },
    style(key){
      let styleObj = {},
          dwd_appid = getUrlQueryVar('appId')
      if(typeof dwd_appid === 'undefined' || dwd_appid === '' ){
        styleObj = {}
      }else{
        if(typeof this.styleMap[dwd_appid] != 'undefined' &&
            typeof this.styleMap[dwd_appid][key] != 'undefined'){
          styleObj = this.styleMap[dwd_appid][key]
        }else{
          styleObj = {}
        }
      }
      if(Object.keys(styleObj).length === 0){
        if(key==='pwdInput'){
          styleObj = {
            width: '230px'
          }
        }
      }
      return styleObj
    },
    async getMobileCode(){
      if(!this.checkMobile(this.username)){
        return 
      }
      let data = this.checkNcParams()
      if(!data){
        this.$emit('resetNc')
        return
      }
      data['mobile'] = this.username
      data['type'] = 8
      data['dwd_appid'] = this.commonParams.state.dwd_appid
      let ret = await this.$apis.getSmsCode(data,null,()=>{
        this.$emit('resetNc')
        return false
      })
      if(!ret){return}
      this._success('短信发送成功')
      this.initSmsCode = true 
    }
  },
}
</script>